<template>
    <div class="fade-carousel" :style="{ '--transition-duration': transitionDuration + 'ms' }">
        <!-- 轮播内容容器：使用 transition 包裹，实现淡入淡出过渡 -->
        <div class="carousel-wrapper" >
            <transition name="slide-up-fade" @before-enter="beforeEnter" @enter="enter" @after-enter="afterEnter">
                <!-- 只渲染当前激活的面板，通过 key 切换触发过渡 -->
                <div class="carousel-panel active" :key="currentIndex"
                
                    v-show="!isAnimating || (isAnimating && isEntering)">
                    <!-- 风格统一的轮播内容 -->
                    <div class="carousel-content"  >
                        <div class="testimonial-card">
                            <!-- 引用符号装饰 -->
                            <div class="quote-icon">
                                <img style="width: 60px;" src="@/assets/images/icons/icon_lainghua_dunhao@3x.png" alt="">
                            </div>

                            <!-- 评价内容 -->
                            <p class="testimonial-content">
                               {{defaultPanels[currentIndex].title }}
                            </p>

                            <!-- 用户头像列表 -->
                            <div class="avatar-list">
                               <img :src="defaultPanels[currentIndex].imgUrl" alt="">
                            </div>

                            <!-- 用户信息 -->
                            <div class="user-info">
                                <div class="user-name">{{ defaultPanels[currentIndex].name }}</div>
                                <div class="user-role">{{ defaultPanels[currentIndex].label }}</div>
                                <div style="color: #838E9F;" class="user-role">{{ defaultPanels[currentIndex].belonging }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
            <div class="carousel-indicators" v-if="showIndicators && defaultPanels.length > 1">
            <span class="indicator-dot" v-for="(item, index) in defaultPanels" :key="index"
                :class="{ active: currentIndex === index }" @click="goToIndex(index)"></span>
        </div>
        </div>

        <!-- 指示器（科技风格） -->
      
    </div>
</template>

<script>
import Image1 from '@/assets/images/icons/icon_touxiang_one@3x.png'
import Image2 from '@/assets/images/icons/icon_touxiang_two@3x.png'
import Image3 from '@/assets/images/icons/icon_touxiang_three@3x.png'
import Image4 from '@/assets/images/icons/icon_touxiang_four@3x.png'
export default {
    name: 'TechFadeCarousel',
    props: {
        autoPlay: { type: Number, default: 4000 },
        transitionDuration: { type: Number, default: 800 }, // 延长动画时长，更平滑
        showIndicators: { type: Boolean, default: true },
        showButtons: { type: Boolean, default: true },
        initialIndex: { type: Number, default: 0 }
    },
    data() {
        return {
            currentIndex: 0, // 当前唯一显示的面板索引
            isAnimating: false, // 动画锁（控制整体动画状态）
            isEntering: false, // 标记是否处于入场动画
            autoPlayTimer: null,
            // 适配风格的默认轮播数据
            avatars: [
                "https://picsum.photos/id/64/60/60",
                "https://picsum.photos/id/65/60/60",
                "https://picsum.photos/id/66/60/60",
                "https://picsum.photos/id/67/60/60"
            ],
            defaultPanels: [
                {
                    title:this.$t('quantify.defaultPanels.title1'),
                    name: 'Hannes',
                    label: this.$t('quantify.defaultPanels.label1'),
                    belonging:this.$t('quantify.defaultPanels.belonging1'),
                    imgUrl:Image1
                },
                {
                    title:this.$t('quantify.defaultPanels.title2'),
                    name: 'Julie',
                    label: this.$t('quantify.defaultPanels.label2'),
                    belonging:this.$t('quantify.defaultPanels.belonging2'),
                    imgUrl: Image4
                },
                {
                    title:this.$t('quantify.defaultPanels.title3'),
                    name:'Olivia',
                    label: this.$t('quantify.defaultPanels.label3'),
                    belonging:this.$t('quantify.defaultPanels.belonging3'),
                    imgUrl: Image2
                },
                {
                    title:this.$t('quantify.defaultPanels.title4'),
                    name: 'Alan',
                    label: this.$t('quantify.defaultPanels.label4'),
                    belonging:this.$t('quantify.defaultPanels.belonging4'),
                    imgUrl: Image3
                },
          
            ]
        };
    },
    watch: {
        autoPlay: {
            handler(newVal) {
                this.stopAutoPlay();
                if (newVal > 0 && this.defaultPanels.length > 1) this.startAutoPlay();
            },
            immediate: true
        }
    },
    mounted() {
        this.currentIndex = Math.min(this.initialIndex, this.defaultPanels.length - 1);
        if (this.autoPlay > 0 && this.defaultPanels.length > 1) this.startAutoPlay();
    },
    beforeDestroy() {
        this.stopAutoPlay();
    },
    methods: {
        startAutoPlay() {
            this.autoPlayTimer = setInterval(() => this.nextIndex(), this.autoPlay);
        },
        stopAutoPlay() {
            if (this.autoPlayTimer) clearInterval(this.autoPlayTimer);
        },
        restartAutoPlay() {
            this.stopAutoPlay();
            if (this.autoPlay > 0 && this.defaultPanels.length > 1) this.startAutoPlay();
        },

        // 下一页：先执行出场动画，再执行入场动画
        nextIndex() {
            if (this.isAnimating || this.defaultPanels.length <= 1) return;
            this.isAnimating = true;

            // 1. 先让当前面板执行“上移+淡出”出场动画
            const panel = document.querySelector('.carousel-panel.active');
            panel.style.transform = 'translateY(-30px)'; // 上移距离稍大，更明显
            panel.style.opacity = 0;

            // 2. 出场动画结束后，切换索引并触发入场动画
            setTimeout(() => {
                this.currentIndex = (this.currentIndex + 1) % this.defaultPanels.length;
                this.isEntering = true; // 标记为入场状态
            }, this.transitionDuration);
        },

        // 上一页：同上逻辑
        prevIndex() {
            if (this.isAnimating || this.defaultPanels.length <= 1) return;
            this.isAnimating = true;

            const panel = document.querySelector('.carousel-panel.active');
            panel.style.transform = 'translateY(-30px)';
            panel.style.opacity = 0;

            setTimeout(() => {
                this.currentIndex = (this.currentIndex - 1 + this.defaultPanels.length) % this.defaultPanels.length;
                this.isEntering = true;
            }, this.transitionDuration);
        },

        // 跳转到指定页
        goToIndex(targetIndex) {
            if (this.isAnimating || this.currentIndex === targetIndex || this.defaultPanels.length <= 1) return;
            this.isAnimating = true;

            const panel = document.querySelector('.carousel-panel.active');
            panel.style.transform = 'translateY(-30px)';
            panel.style.opacity = 0;

            setTimeout(() => {
                this.currentIndex = targetIndex;
                this.isEntering = true;
            }, this.transitionDuration);
        },

        // 过渡动画：入场前初始化样式（从下方20px、透明开始）
        beforeEnter(el) {
            el.style.transform = 'translateY(20px)';
            el.style.opacity = 0;
        },

        // 过渡动画：入场执行（回到中间、完全显示）
        enter(el, done) {
            // 强制回流，确保动画生效
            el.offsetHeight;
            el.style.transform = 'translateY(0)';
            el.style.opacity = 1;
            // 动画结束后调用 done 回调
            setTimeout(() => {
                done();
            }, this.transitionDuration);
        },

        // 过渡动画：入场结束后重置状态
        afterEnter() {
            this.isAnimating = false;
            this.isEntering = false;
            this.restartAutoPlay();
        }
    }
};
</script>

<style scoped>
.testimonial-card {
    position: relative;
    width: 100%;
    max-width: 800px;
    padding: 40px 30px;
    background-color: #171524;
    /* 深色背景，与Matrix风格一致 */
    color: #fff;
    font-family: "Microsoft Yahei", sans-serif;
    border-radius: 8px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
   align-items: center;
}

/* 引用符号装饰 */
.quote-icon {
    /* position: absolute; */

    font-size: 48px;
    color: #FFD700;
    /* 金色点缀 */
    opacity: 0.6;
}

.quote-icon span {
    display: block;
    line-height: 1;
}

/* 评价内容 */
.testimonial-content {
    font-size: 16px;
    line-height: 1.8;
    color: rgba(255, 255, 255, 0.8);
    margin: 0 0 30px 0;
    padding-top: 20px;
    text-align: center;
    /* 避开引用符号 */
}

/* 头像列表 */
.avatar-list {
    display: flex;
    gap: 8px;
    margin-bottom: 15px;
    border-radius: 50%;
    width: 80px;
    border: 2px solid #F3B701;
}

.avatar-item {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #171524;

    /* 避免头像重叠时的边框冲突 */
    /* 层叠效果：最后一个头像在最上层 */
    &:nth-child(2) {
        margin-left: -10px;
    }

    &:nth-child(3) {
        margin-left: -10px;
    }

    &:nth-child(4) {
        margin-left: -10px;
    }
}

/* 用户信息 */
.user-info {
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.user-name {
    color: #F5F5F5;
    /* 金色用户名 */
    /* font-weight: 600; */
    /* margin-right: 8px; */
    font-size: 18px;
}

.user-role {
    color:#F3B701;
}

/* 响应式适配（H5） */
@media (max-width: 768px) {
    .testimonial-card {
        padding: 30px 20px;
    }

    .testimonial-content {
        font-size: 14px;
    }

    .avatar-item {
        width: 40px;
        height: 40px;
    }
}

/* 整体深色科技风格 */
.fade-carousel {
    position: relative;
    width: 100%;
    height: 500px;
    min-height: 600px;
    overflow: hidden;
    background-color: #171524;
    /* 与示例图一致的深黑底色 */
    color: #fff;
    font-family: "Microsoft Yahei", sans-serif;
}

/* 轮播容器 */
.carousel-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
}

/* 轮播面板：每次只渲染一个，彻底解决重叠 */
.carousel-panel {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* 关键：使用贝塞尔曲线让动画更丝滑（先慢后快再慢） */
    transition: transform var(--transition-duration) cubic-bezier(0.25, 0.1, 0.25, 1),
        opacity var(--transition-duration) cubic-bezier(0.25, 0.1, 0.25, 1);
    will-change: transform, opacity;
    /* 性能优化，提前告知浏览器准备动画 */
    padding: 0 80px;
    display: flex;
    align-items: center;
}

/* 轮播内容布局（左右分栏） */
.carousel-content {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.content-left {
    flex: 1;
    max-width: 500px;
}

.content-right {
    flex: 1;
    display: flex;
    justify-content: flex-end;
}

/* 文字样式（匹配示例图） */
.panel-title {
    font-size: 42px;
    font-weight: bold;
    color: #fff;
    margin-bottom: 20px;
    line-height: 1.2;
}

.panel-desc {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.7);
    line-height: 1.6;
    margin-bottom: 30px;
}

/* 按钮样式（金色高亮） */
.explore-btn {
    padding: 12px 28px;
    background-color: #FFD700;
    /* 示例图中的金色按钮 */
    color: #171524;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.explore-btn:hover {
    background-color: #ffdf40;
}

/* 图片样式 */
.panel-img {
    width: 400px;
    height: 300px;
    object-fit: cover;
    border-radius: 8px;
    /* 科技感阴影 */
    box-shadow: 0 0 30px rgba(255, 215, 0, 0.2);
}

/* 指示器（科技风格） */
.carousel-indicators {
    position: absolute;
    /* bottom: 40px;
    left: 0;
    right: 0; */
    display: flex;
    justify-content: center;
    gap: 10px;
    z-index: 10;
    margin-top: 30px;
    bottom: 0;
}

.indicator-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.2);
    cursor: pointer;
    transition: all 0.3s ease;
}

.indicator-dot.active {
    width: 30px;
    background-color: #FFD700;
    border-radius: 5px;
}

/* 切换按钮（深色透明）- 保留样式，如需显示可取消注释 */
.carousel-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 215, 0, 0.3);
    cursor: pointer;
    z-index: 10;
    transition: background-color 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.carousel-btn:hover {
    background-color: rgba(255, 255, 255, 0.2);
}

.carousel-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.prev-btn {
    left: 30px;
}

.next-btn {
    right: 30px;
}

/* H5适配 */
@media (max-width: 768px) {
    .fade-carousel {
        /* height: 400px; */
        padding: 0 20px;
    }

    .carousel-panel {
        padding: 0 20px;
    }

    .carousel-content {
        flex-direction: column;
        justify-content: center;
        text-align: center;
    }

    .content-right {
        justify-content: center;
        margin-top: 20px;
    }

    .panel-title {
        font-size: 28px;
    }

    .panel-img {
        width: 250px;
        height: 180px;
    }

    .carousel-btn {
        width: 40px;
        height: 40px;
    }

    .prev-btn {
        left: 15px;
    }

    .next-btn {
        right: 15px;
    }

    .carousel-indicators {
        bottom: 0px;
        z-index: 999;
        /* margin-top: 20px; */
    }
}
</style>